import React from 'react';

interface ShinyTextProps {
  text: string;
  className?: string;
  speed?: number;
  disabled?: boolean;
}

const ShinyText: React.FC<ShinyTextProps> = ({
  text,
  className = '',
  speed = 3,
  disabled = false,
}) => {
  const animationDuration = `${speed}s`;

  return (
    <span
      className={`inline-block bg-clip-text text-transparent ${disabled ? '' : 'shiny-text-animation'} ${className}`}
      style={{
        backgroundImage: disabled
          ? 'linear-gradient(135deg, #667eea, #764ba2)'
          : 'linear-gradient(120deg, #667eea 0%, #764ba2 20%, #ffffff 40%, #a78bfa 60%, #667eea 80%, #764ba2 100%)',
        backgroundSize: '250% 100%',
        animationDuration,
      }}
    >
      {text}
    </span>
  );
};

export default ShinyText;
